import { render } from "./SubmitItem.vue?vue&type=template&id=2af40a18&scoped=true"
import script from "./SubmitItem.vue?vue&type=script&lang=js"
export * from "./SubmitItem.vue?vue&type=script&lang=js"

import "./SubmitItem.vue?vue&type=style&index=0&id=2af40a18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af40a18"]])

export default __exports__